// ponytail: versión simplificada del slice warehouses — solo inventarios seminuevos + loading.
// Sin warehouses (es uno solo), sin reservas (no aplica "Apartar"), sin products-by-warehouse.
const actions = {
  GET_DATA_SEMINUEVOS: 'GET_DATA_SEMINUEVOS',
  SET_DATA_SEMINUEVOS: 'SET_DATA_SEMINUEVOS',
  GET_DATA_BEGIN_SEMINUEVOS: 'GET_DATA_BEGIN_SEMINUEVOS',
  GET_DATA_FINISH_SEMINUEVOS: 'GET_DATA_FINISH_SEMINUEVOS',

  setSeminuevos: (data: any) => ({
    type: actions.SET_DATA_SEMINUEVOS,
    data,
  }),
  getSeminuevosBegin: () => ({
    type: actions.GET_DATA_BEGIN_SEMINUEVOS
  }),
  getSeminuevosFinish: () => ({
    type: actions.GET_DATA_FINISH_SEMINUEVOS
  }),
};

export default actions;
